import styled from 'styled-components';

import { TopNavMenu } from './TopNavMenu';

const TopNavCollapsibleMenu = styled(TopNavMenu)`
   overflow: auto;
`;

TopNavCollapsibleMenu.defaultProps = {
   'data-rcl-collapsible-menu': true,
};

export { TopNavCollapsibleMenu };
